import React, { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { deleteData, getData } from "../../services/http.service";
import Constants from "../../services/constant";
// import profile from "../assets/demo/flags/profile.png";
import { Button } from "primereact/button";
import { Link } from "react-router-dom";
import { Rating } from "primereact/rating";
import { formatDate } from "../../utils/dateConversions";
import dummy from "../../assets/images/dummy1.png"
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
const TargetPoint = () => {
    const toast = useRef(null);
    useEffect(() => {
        getAllTargetPoint();
    }, []);
    const getAllTargetPoint = () => {
        getData(Constants.END_POINT.ALL_TARGET_POINT)
            .then((res) => {
                if (res.success) {
                    setTargetPoint(res.data);
                    setLoading(false)
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const deleteTargetPoint = (id) => {
        deleteData(Constants.END_POINT.DELETE_TARGET_POINT+id)
        .then((res)=>{
            if(res.success){
                toast.current.show({ severity: "info", summary: "", detail: "Target point Deleted Succesfully", life: 3000 });
                getAllTargetPoint();
            }
        })
    }

    const [targetPoint, setTargetPoint] = useState();
    const [loading, setLoading] = useState(true);

    const targetPointImageTemplate = (rowData) => {
        return <img src={rowData?.image ? Constants.BASE_URL+rowData?.image :dummy} style={{width:"70px",height:"70px"}}/>
    }

    const acceptFunc = (id) => {
        deleteTargetPoint(id)
        // toast.current.show({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 3000 });
    }

    const reject = () => {
        // toast.current.show({ severity: 'warn', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
    }

    const deleteConfirm = (id) => {
        confirmDialog({
            message: 'Do you want to delete this record?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            rejectClassName:'cancel-button',
            accept:()=>acceptFunc(id),
            reject
        });
    };

    const ActionBodyTemplate = (rowData) => {
        return (
            <div className="flex">
                <Link to={`/target-point-edit/${rowData?._id}`}>
                    <Button type="button" className="p-button-info mx-2">
                        Edit
                    </Button>
                </Link>

                <Button
                    type="button"
                    className="p-button-danger "
                    onClick={()=>deleteConfirm(rowData?._id)}
                >
                    Delete
                </Button>   
            </div>
        );
    };

    const MaxTimeTemplate = (rowData) => {
return (
    <div>
        {rowData.maxTime + ` hours`}
    </div>
)
    }

    const MinTimeTemplate = (rowData) => {
        return (
            <div>
                {rowData.minTime + ` hours`}
            </div>
        )
            }

    return (
        <div className="col-12">
            <div className="card">
            <div className="flex justify-content-between mb-4">
            <Toast ref={toast} />
                        <h5>Target Point</h5>
                        <div className="flex justify-content-end mr-3">
                            <Link to="/create-target-point">
                                <Button className="p-button-info" icon="pi pi-plus" label="Create Target Point" />
                            </Link>
                            {/* <Button label="Export" icon="pi pi-upload" className="p-button-help ml-3" onClick={() => ExportCSV(exportData)} /> */}
                        </div>
                    </div>
                <DataTable value={targetPoint} paginator rows={10} loading={loading}>
                    <Column field="pointName"  header="Target Point Name" sortable  />
                    {/* <Column field="business.businessName" header="Business Name" sortable style={{ width: "30px" }} /> */}
                    <Column field="image" header="Image" sortable  body={targetPointImageTemplate} />
                    <Column field="maxTime"  header="maximum Time" sortable body={MaxTimeTemplate}  />
                    <Column field="minTime"  header="minimum Time" sortable body={MinTimeTemplate} />
                    {/* <Column field="business.isVerified" header="Status" sortable body={statusBodyTemplate2} style={{ width: "30px" }} />
                    <Column field="time" header="Created On" sortable body={(d) => formatDate(new Date(d.time))} style={{ width: "30px" }} /> */}
                    <Column field="block" header="Action" body={ActionBodyTemplate} style={{width:'10px'}} />
                </DataTable>
            </div>
        </div>
    );
};

export default TargetPoint;
